import { render } from "./categorie_img.vue?vue&type=template&id=634f2dd9&scoped=true&ts=true"
import script from "./categorie_img.vue?vue&type=script&lang=ts"
export * from "./categorie_img.vue?vue&type=script&lang=ts"

import "./categorie_img.vue?vue&type=style&index=0&id=634f2dd9&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-634f2dd9"]])

export default __exports__